// extracted by mini-css-extract-plugin
module.exports = {"highlight":"week-day_highlight__l32IE"};